import { formatMoney } from './utils-format-money.js';

class ProductPrice extends HTMLElement {
  hasPopularAddOns = this.hasAttribute('data-synced-with-product-add-ons') || false;

  connectedCallback() {
    this.mainProduct = this.closest('main-product') || document.querySelector('main-product[data-is-main-product]');
    this.sectionId = this.dataset.sectionId || this.mainProduct?.dataset.sectionId;
    this.popularAddOns = this.mainProduct?.getPopularAddOns() || [];

    this.handleAddOnPriceChange();

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}:${this.sectionId}`,
      ({ html }) => {
        this.handlePriceChange(html);
      }
    );

    // Make sure the product is a add-on
    if (!this.hasPopularAddOns) return;

    this.unsubscribePriceChanged = subscribe(
      `price:changed:product-add-ons:${this.sectionId}`,
      ({ priceInCents, compareAtPriceInCents }) => {
        this.updatePriceWith(priceInCents);
        this.updateCompareAtPriceWith(compareAtPriceInCents);
      }
    );
  }

  handleAddOnPriceChange() {
    // Check if the product
    if (!this.hasPopularAddOns) return;

    // Update the price with the add-on value
    const addOnValue = parseInt(this.popularAddOns.reduce((total, item) => total + item.price, 0));
    this.updatePriceWith(addOnValue);

    // Update the compare price with the add-on value
    const compareAtPriceValue = parseInt(
      this.popularAddOns.reduce((total, item) => total + (item.compareAtPrice || item.price), 0)
    );
    this.updateCompareAtPriceWith(compareAtPriceValue);
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    if (this.hasPopularAddOns) {
      this.unsubscribePriceChanged();
    }
  }

  /**
   * Handle price change.
   * @param {HTMLElement} html - The HTML to render.
   */
  handlePriceChange(html) {
    const productPrice = html.querySelector('product-price');
    this.innerHTML = productPrice.innerHTML;
  }

  updatePriceWith(cents) {
    // Only update the price if the cents are set in the data attribute
    if (!this.dataset.price) return;

    this.querySelector('[data-current-price]').textContent = formatMoney(
      cents + parseInt(this.dataset.price)
    );
  }

  /**
   * @method updateCompareAtPriceWith
   * @param {number} cents - The cents to update the compare price with.
   * @returns {void}
   */
  updateCompareAtPriceWith(cents) {
    // Only update the price if the cents are set in the data attribute
    if (!this.dataset.compareAtPrice) return;
    const compareAtPrice = this.querySelector('[data-current-compare-at-price]');
    if (!compareAtPrice) return;
    compareAtPrice.textContent = formatMoney(
      cents + parseInt(this.dataset.compareAtPrice),
      window.SHOP_MONEY_FORMAT
    );
  }
}

customElements.define('product-price', ProductPrice);
